import { render, staticRenderFns } from "./StTeaserArticlesHome.vue?vue&type=template&id=1e44917d"
import script from "./StTeaserArticlesHome.vue?vue&type=script&lang=ts"
export * from "./StTeaserArticlesHome.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports